import React, { useState } from 'react';

const ThankYou = () => {
  const [showMessage, setShowMessage] = useState(false);

  const handleThankClick = () => {
    setShowMessage(true);
  };

  const handleCloseClick = () => {
    setShowMessage(false);
  };

  return (
    <div className="thankyoudiv">
      {!showMessage ? (
        <div className="button-container">
          <button className="thank-button" onClick={handleThankClick}>
            Thank You
          </button>
        </div>
      ) : (
        <div className="thank-message-div">
          <button className="close-button" onClick={handleCloseClick}>
            &times;
          </button>
          <p className="thank-message">
            {/* We thank you, our valued customers, for choosing us! */}
            Thank you for choosing us! Your trust inspires us to bring you the best sweets and snacks for every occasion.
          </p>
        </div>
      )}
    </div>
  );
};

export default ThankYou;
